import React, { useState } from "react";
import '../../Styles/ValuatorStyles/CaseComponent.css'
import  useNavigation  from "../../hooks/useNavigation";
import AdminDropdown from "../AdminDropDown";

function CaseComponent({ cases, isArchivedPage, selectedCompany, setSelectedCompany, companies }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState('ascending');
  const { navigateTo } = useNavigation();

  const sortedAndFilteredCases = cases
  .filter((caseItem) => caseItem.id.includes(searchQuery))
  .sort((a, b) => {
    if (sortOrder === 'ascending') {
      return a.id.localeCompare(b.id);
    } else {
      return b.id.localeCompare(a.id);
    }
  });
    const handleCaseClick = (caseId, caseRating) => {
      const path = isArchivedPage ? `/valuator/archived-cases/${caseId}` : `/valuator/cases/${caseId}`;
      navigateTo(path, { state: { rating: caseRating } });
    };
  return (
    <>
      <div className="container case-page-container">
      <h1 className="main-header">Vælg sag</h1>
        <AdminDropdown
          allCompanies={companies}
          setSelectedCompany={setSelectedCompany}
          selectedCompany={selectedCompany}>            
        </AdminDropdown>
      <button className="back-btn2" onClick={() => navigateTo('/valuator')}>Tilbage til Dashboard</button>
        <div className="case-select-container">
          <div className="controls-container">
            <button
              className="sort-button"
              onClick={() => setSortOrder(sortOrder === 'ascending' ? 'descending' : 'ascending')}
            >
              Sorter {sortOrder === 'ascending' ? 'stigende' : 'faldende'}
            </button>
            <input
              type="text"
              className="search-input"
              placeholder="søg efter sag.."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

                  <ul>
          {sortedAndFilteredCases && Array.isArray(sortedAndFilteredCases) && sortedAndFilteredCases.map((caseItem) => (
            <li className="list" key={caseItem.id} onClick={() => handleCaseClick(caseItem.id)}>
              {caseItem.id}
            </li>
          ))}
        </ul>

        </div>
      </div>
    </>
  );
}
export default CaseComponent;
